import { selection, timePeriods } from '../../../utils/filter';
import { displayByFactory, advancedFactory } from './categories';

const getRaceType = val => val.match(/jumps|flat/)[0];
const getCountry = val => val.match(/GB|IRE/)[0];
const { hasValue, getValue } = selection;

const RACE_TYPE = 'raceType';
const DISPLAY_BY = 'displayBy';

/**
 * Time periods format should change in the following way:
 * for flat - YYYY,
 * for jumps - YYYY-YY
 */
const timePeriodReducer = (categories, { type, value }) => {
    const { timePeriod } = categories;
    const { seasonsAvailable } = timePeriod;
    const {
        getRaceTypeStartYear,
        getCurrentSeasonEndYear,
        getPeriods,
        getAll,
        getCurrent,
        getLast5,
    } = timePeriods;

    if (!hasValue(categories[type], value)) {
        return categories.timePeriod;
    }

    if (type === RACE_TYPE) {
        const nextRaceType = getRaceType(value);
        const country = getCountry(value);
        const startYear = getRaceTypeStartYear(nextRaceType, country, seasonsAvailable);
        const endYear = getCurrentSeasonEndYear(nextRaceType, country);
        const lastFivePeriods = getPeriods(endYear - 1, endYear - 6, nextRaceType);
        const newOptions = [
            getAll(startYear, endYear),
            getCurrent(endYear, nextRaceType),
            getLast5(endYear, nextRaceType),
            ...lastFivePeriods,
        ];
        newOptions[0].selected = true;
        return {
            ...timePeriod,
            options: newOptions,
            title: 'time period',
            createdBy: {
                raceType: nextRaceType,
            },
        };
    }
    return timePeriod;
};
/**
 * Display by options should change alongside with race type,
 * for race type specific Display by options see ./categories.js
 *
 * If selected display by option is present for jumps and flat race types -
 * keep it selected and vice versa.
 */
const displayByReducer = (categories, { type, value }) => {
    if (!hasValue(categories[type], value)) {
        return categories.displayBy;
    }

    if (type === RACE_TYPE) {
        const raceType = getRaceType(value);
        const country = getCountry(value);
        const displayBy = categories.displayBy;

        return displayByFactory(
            country,
            raceType,
            categories.displayBy.createdBy.humanType,
            displayBy
                .options
                .find(o => o.selected)
                .value
        );
    }
    return categories.displayBy;
};
/**
 * Race type does not depend on other selected values.
 */
const raceTypeReducer = categories => categories.raceType;
/**
 * Advanced options should be shown only if value,
 * selected in display by category is present for
 * flat and jumps race types.
 *
 * If race type changes and generic display by value is selected -
 * race type specific advanced options should be added to advanced category
 */
const advancedReducer = (categories, { type, value }) => {
    if (!hasValue(categories[type], value)) {
        return categories.advanced;
    }

    const humanType = categories.displayBy.createdBy.humanType;
    switch (type) {
        case DISPLAY_BY: {
            const selectedType = getValue(categories, RACE_TYPE);
            const raceType = getRaceType(selectedType);
            const country = getCountry(selectedType);

            return advancedFactory(country, raceType, value, humanType);
        }

        case RACE_TYPE: {
            const raceType = getRaceType(value);
            const country = getCountry(value);
            const displayBy = getValue(categories, DISPLAY_BY);

            return advancedFactory(country, raceType, displayBy, humanType);
        }

        default:
            return categories.advanced;

    }
};
/**
 * Reducers composition
 */
const categoriesReducer = (categories, action) => ({
    raceType: raceTypeReducer(categories),
    displayBy: displayByReducer(categories, action),
    timePeriod: timePeriodReducer(categories, action),
    advanced: advancedReducer(categories, action),
});

export default categoriesReducer;



// WEBPACK FOOTER //
// ./src/js/human/stats/statsTable/categoriesReducer.js